import type { BannerProps } from './types';

export function getBannerDisplay({ size, title, description, cta, headingTagName }: BannerProps) {
    const trimmedTitle = title?.trim() ?? '';

    return {
        title: trimmedTitle && (size === 'sm' ? trimmedTitle.slice(0, 75) : trimmedTitle),
        headingTagName: trimmedTitle ? headingTagName : ('span' as BannerProps['headingTagName']),
        description: description && (size === 'lg' || size === 'xlg') ? description : undefined,
        descriptionSize: size === 'xlg' ? ('xlg' as const) : undefined,
        showCta: !!cta && size !== 'md-alt' && size !== 'xlg',
    };
}
